import { NewAndCurrentPasswordsObject, TosItem } from '@bepatient/common';
import { Action } from '@ngrx/store';
import { MyAccountForm, PageDetail } from './my-account.models';
import { ViewContainerRef } from '@angular/core';

export enum MyAccountActionsTypes {
  LOAD_FORMS = '[MyAccountAction] Load forms',
  LOAD_FORMS_FAILED = '[MyAccountAction] Load forms failed',
  LOAD_FORMS_SUCCESS = '[MyAccountAction] Load forms success',
  LOAD_TOS_ITEMS = '[MyAccountAction] Load TOS items',
  LOAD_TOS_ITEMS_FAILED = '[MyAccountAction] Load TOS items failed',
  LOAD_TOS_ITEMS_SUCCESS = '[MyAccountAction] Load TOS items success',
  LOAD_TOS_ITEMS_V2 = '[MyAccountAction] Load TOS items v2',
  LOAD_TOS_ITEMS_V2_FAILED = '[MyAccountAction] Load TOS items v2 failed',
  LOAD_TOS_ITEMS_V2_SUCCESS = '[MyAccountAction] Load TOS items v2 success',
  LOAD_TOS_ITEM_DETAILS = '[MyAccountAction] Load TOS item details',
  LOAD_TOS_ITEM_DETAILS_FAILED = '[MyAccountAction] Load TOS item details failed',
  LOAD_TOS_ITEM_DETAILS_SUCCESS = '[MyAccountAction] Load TOS item details success',
  LOAD_HELP = '[MyAccountAction] Load help',
  LOAD_HELP_SUCCESS = '[MyAccountAction] Load help success',
  LOAD_HELP_FAILED = '[MyAccountAction] Load help failed',
  SET_SELECTED_TOS_INDEX = '[MyAccountAction] Set selected TOS index',
  SET_NEW_PASSWORD = '[MyAccountAction] Set new password',
  SET_NEW_PASSWORD_FAILED = '[MyAccountAction] Set new password failed',
  SET_NEW_PASSWORD_SUCCESS = '[MyAccountAction] Set new password success',
  LOAD_FORM_HREF = '[MyAccountAction] Load form href',
  LOAD_FORM_HREF_FAILED = '[MyAccountAction] Load form href failed',
  SET_NEW_EMAIL = '[MyAccountAction] Set new email',
  SET_NEW_EMAIL_FAILED = '[MyAccountAction] Set new email failed',
  SET_NEW_EMAIL_SUCCESS = '[MyAccountAction] Set new email success',
  LOAD_DOCUMENT = '[MyAccountAction] Load Document',
  LOAD_DOCUMENT_SUCCESS = '[MyAccountAction] Load Document success',
  LOAD_DOCUMENT_FAILED = '[MyAccountAction] Load Document failed',
  SET_USER_PREFERENCE = '[MyAccountAction] Set user preference',
  SET_USER_PREFERENCE_SUCCESS = '[MyAccountAction] Set user preference success',
  SET_USER_PREFERENCE_FAILED = '[MyAccountAction] Set user preference failed',
  USER_LANGUAGE_CHANGED = '[MyAccountAction] User language changed',
  SET_SELECTED_SETTING_TYPE = '[MyAccountAction] Set selected setting type',
  SET_PREVIOUS_SETTING_TYPE = '[MyAccountAction] Set previous setting type'
}

export class MyAccountActionLoadForms implements Action {
  readonly type = MyAccountActionsTypes.LOAD_FORMS;
}

export class MyAccountActionLoadFormsFailed implements Action {
  readonly type = MyAccountActionsTypes.LOAD_FORMS_FAILED;
}

export class MyAccountActionLoadFormsSuccess implements Action {
  readonly type = MyAccountActionsTypes.LOAD_FORMS_SUCCESS;

  constructor(public payload: Array<MyAccountForm>) {}
}

export class MyAccountActionLoadTosItems implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEMS;
}

export class MyAccountActionLoadTosItemsFailed implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEMS_FAILED;
}

export class MyAccountActionLoadTosItemsSuccess implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEMS_SUCCESS;

  constructor(public payload: Array<TosItem>) {}
}

export class MyAccountActionLoadTosItemsV2 implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEMS_V2;

  constructor(public payload: string) {}
}

export class MyAccountActionLoadTosItemsV2Failed implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEMS_V2_FAILED;
}

export class MyAccountActionLoadTosItemsV2Success implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEMS_V2_SUCCESS;

  constructor(public payload: Array<TosItem>) {}
}

export class MyAccountActionLoadTosItemDetails implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEM_DETAILS;

  constructor(public payload: string) {}
}

export class MyAccountActionLoadTosItemDetailsFailed implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEM_DETAILS_FAILED;
}

export class MyAccountActionLoadTosItemDetailsSuccess implements Action {
  readonly type = MyAccountActionsTypes.LOAD_TOS_ITEM_DETAILS_SUCCESS;

  constructor(public payload: any) {}
}

export class MyAccountActionSetSelectedTosIndex implements Action {
  readonly type = MyAccountActionsTypes.SET_SELECTED_TOS_INDEX;

  constructor(public payload: number) {}
}

export class MyAccountActionSetNewPassword implements Action {
  readonly type = MyAccountActionsTypes.SET_NEW_PASSWORD;
  constructor(
    public payload: {
      request: NewAndCurrentPasswordsObject;
      viewContainerRef: ViewContainerRef;
    }
  ) {}
}

export class MyAccountActionSetNewPasswordSuccess implements Action {
  readonly type = MyAccountActionsTypes.SET_NEW_PASSWORD_SUCCESS;
}

export class MyAccountActionSetNewPasswordFailed implements Action {
  readonly type = MyAccountActionsTypes.SET_NEW_PASSWORD_FAILED;
}

export class MyAccountActionLoadFormHref implements Action {
  readonly type = MyAccountActionsTypes.LOAD_FORM_HREF;

  constructor(public payload: string) {}
}

export class MyAccountActionLoadFormHrefFailed implements Action {
  readonly type = MyAccountActionsTypes.LOAD_FORM_HREF_FAILED;
}
export class MyAccountActionSetNewEmail implements Action {
  readonly type = MyAccountActionsTypes.SET_NEW_EMAIL;

  constructor(
    public payload: {
      oldEmail: string;
      newEmailConfirmation: string;
      newEmail: string;
    }
  ) {}
}

export class MyAccountActionSetNewEmailFailed implements Action {
  readonly type = MyAccountActionsTypes.SET_NEW_EMAIL_FAILED;

  constructor(public payload: string) {}
}

export class MyAccountActionSetNewEmailSuccess implements Action {
  readonly type = MyAccountActionsTypes.SET_NEW_EMAIL_SUCCESS;

  constructor(public payload: string) {}
}

export class MyAccountActionLoadDocument implements Action {
  readonly type = MyAccountActionsTypes.LOAD_DOCUMENT;

  constructor(public payload: string) {}
}

export class MyAccountActionLoadDocumentSuccess implements Action {
  readonly type = MyAccountActionsTypes.LOAD_DOCUMENT_SUCCESS;

  constructor(public payload: any) {}
}

export class MyAccountActionLoadDocumentFailed implements Action {
  readonly type = MyAccountActionsTypes.LOAD_DOCUMENT_FAILED;
}

export class MyAccountActionSetUserPreference implements Action {
  readonly type = MyAccountActionsTypes.SET_USER_PREFERENCE;

  constructor(public payload: any) {}
}

export class MyAccountActionSetUserPreferenceSuccess implements Action {
  readonly type = MyAccountActionsTypes.SET_USER_PREFERENCE_SUCCESS;

  constructor(public payload?: any) {}
}

export class MyAccountActionSetUserPreferenceFailed implements Action {
  readonly type = MyAccountActionsTypes.SET_USER_PREFERENCE_FAILED;
}

export class MyAccountActionUserLanguageChanged implements Action {
  readonly type = MyAccountActionsTypes.USER_LANGUAGE_CHANGED;

  constructor(public payload: string) {}
}

export class MyAccountActionLoadHelp implements Action {
  readonly type = MyAccountActionsTypes.LOAD_HELP;
}

export class MyAccountActionLoadHelpFailed implements Action {
  readonly type = MyAccountActionsTypes.LOAD_HELP_FAILED;
}

export class MyAccountActionLoadHelpSuccess implements Action {
  readonly type = MyAccountActionsTypes.LOAD_HELP_SUCCESS;

  constructor(public payload: any) {}
}

export class MyAccountActionSetSelectedSettingType implements Action {
  readonly type = MyAccountActionsTypes.SET_SELECTED_SETTING_TYPE;

  constructor(public payload: any) {}
}

export class MyAccountActionSetPreviousSettingType implements Action {
  readonly type = MyAccountActionsTypes.SET_PREVIOUS_SETTING_TYPE;

  constructor(public payload: PageDetail) {}
}

export type MyAccountActions =
  | MyAccountActionLoadForms
  | MyAccountActionLoadFormsFailed
  | MyAccountActionLoadFormsSuccess
  | MyAccountActionLoadTosItems
  | MyAccountActionLoadTosItemsFailed
  | MyAccountActionLoadTosItemsSuccess
  | MyAccountActionLoadTosItemsV2
  | MyAccountActionLoadTosItemsV2Failed
  | MyAccountActionLoadTosItemsV2Success
  | MyAccountActionLoadTosItemDetails
  | MyAccountActionLoadTosItemDetailsFailed
  | MyAccountActionLoadTosItemDetailsSuccess
  | MyAccountActionSetSelectedTosIndex
  | MyAccountActionSetNewPassword
  | MyAccountActionSetNewPasswordSuccess
  | MyAccountActionSetNewPasswordFailed
  | MyAccountActionLoadFormHref
  | MyAccountActionLoadFormHrefFailed
  | MyAccountActionSetNewEmail
  | MyAccountActionSetNewEmailFailed
  | MyAccountActionSetNewEmailSuccess
  | MyAccountActionLoadDocument
  | MyAccountActionLoadDocumentSuccess
  | MyAccountActionLoadDocumentFailed
  | MyAccountActionSetUserPreference
  | MyAccountActionSetUserPreferenceSuccess
  | MyAccountActionSetUserPreferenceFailed
  | MyAccountActionUserLanguageChanged
  | MyAccountActionLoadHelp
  | MyAccountActionLoadHelpSuccess
  | MyAccountActionLoadHelpFailed
  | MyAccountActionSetSelectedSettingType
  | MyAccountActionSetPreviousSettingType;
